import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Row, Modal, Col, ModalBody, ListGroup, ModalHeader } from 'reactstrap';
import { SvgAssets } from '../../../assets/icons/iconSvg';
import c from '../../../constants/Colors';

const ModalConfirmarCarrito = (props) => {
    const VISIBLE = props.visible;
    const TOGGLE_MODAL = props.toggle;
    const TITULO = props.titulo;
    const MENSAJE = props.mensaje.split('@');
    return (
        <div>
            <Modal returnFocusAfterClose={false}
                isOpen={VISIBLE} toggle={() => TOGGLE_MODAL([])} className='modal_compatible' centered backdrop="static">
                {/* <ModalHeader>
                    <button className="btn-icon modal-close" onClick={() => props.toggle(false)}><SvgAssets icon="icon-close" fill={c.celeste} /></button>
                    <h6 style={{ color: '#fff' }}>
                        <SvgAssets icon="icon-check" fill={'#fff'} className="mr-3" />
                        {TITULO}
                    </h6>
                </ModalHeader> */}
                <ModalBody>
                    <ListGroup flush className="list-group-desktop">
                        <div className='content-scroll'>
                            {
                                MENSAJE.map((item, index) => {
                                    return (
                                        <p key={"text_" + index} className="paragraph-3" style={{ color: c.grisMedio }}>{item}</p>
                                    )
                                })
                            }

                        </div>
                    </ListGroup>

                    <div className="row">
                        <div className="col-4">
                            <button
                                className="btn-block bg_verde"
                                type="button"
                                onClick={() => TOGGLE_MODAL([])}
                            >
                                SI
                            </button>
                        </div>
                        <div className="col-2"><br /></div>
                        <div className="col-3">
                            <button
                                className="btn-block bg_rojo"
                                type="button"
                                onClick={() =>
                                    props.postActualizarStockPorLimites(props.auth.setcarritoProdctos, props.data)
                                }
                            >
                                NO
                            </button>
                        </div>
                    </div>

                </ModalBody>
            </Modal>
        </div>
    )
}

export default ModalConfirmarCarrito;